import { render, staticRenderFns } from "./HeaderMenuCatalog.vue?vue&type=template&id=19ade203&"
import script from "./HeaderMenuCatalog.vue?vue&type=script&lang=js&"
export * from "./HeaderMenuCatalog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports